import { render, staticRenderFns } from "./labelIconClass-editor.vue?vue&type=template&id=bf705736&scoped=true&"
import script from "./labelIconClass-editor.vue?vue&type=script&lang=js&"
export * from "./labelIconClass-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf705736",
  null
  
)

export default component.exports